import * as z from "zod";
import { CountryValidationSchema } from "./countryValidationSchema";

const baseSchema = z.object({
  address: z.string({ message: "validation:addressRequired" }).min(1, { message: "validation:addressRequired" }),
  address2: z.string().optional(),
  address3: z.string().optional(),
  postCode: z.string({ message: "validation:postCodeRequired" }).min(1, { message: "validation:postCodeRequired" }),
  place: z.string({ message: "validation:placeRequired" }).min(1, { message: "validation:placeRequired" }),
  regionId: z.number().optional(),
  addressType: z
    .string({ message: "validation:addressTypeRequired" })
    .min(1, { message: "validation:addressTypeRequired" }),
});

const withCountryId = baseSchema.extend({
  countryId: z.string({ message: "validation:countryRequired" }).min(1, { message: "validation:countryRequired" }),
});

const withCountry = baseSchema.extend({
  country: CountryValidationSchema,
});

export function addressValidationSchema(useCountryId: true): typeof withCountryId;
export function addressValidationSchema(useCountryId: false): typeof withCountry;
export function addressValidationSchema(useCountryId: boolean) {
  return useCountryId ? withCountryId : withCountry;
}

// Default (countryId variant) kept for backwards compatibility
export const AddressValidationSchema = withCountryId;
export type AddressFormInput = z.infer<typeof withCountryId>;
export type AddressWithCountryFormInput = z.infer<typeof withCountry>;
// Update targets an existing address, so the backend needs its id to bind the request.
export type UpdateAddressInput = AddressWithCountryFormInput & { id: number };
